module.exports = __webpack_public_path__ + "img/markerblue.6e34501d.svg";